import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import Table from '../../../core/form/Table';
import Button from '../../../core/form/Button';
import Tag from '../../../core/layout/Tag';
import { Tooltip } from 'antd';
import Icon from '../../../core/layout/Icon';

const PlacementTestList = (props) => (
  <div>
    <Table
      fetching={props.fetching}
      columns={[
        {
          label: 'Level',
          path: 'placementTestLevel.level',
          width: '70px',
          sort: true,
        },
        {
          label: 'Order',
          path: 'order',
          width: '75px',
          sort: true,
        },
        {
          label: 'Grammar',
          path: 'grammar.name',
        },
        {
          label: 'Items Count',
          path: 'items',
          width: '105px',
          render: (cell) => cell.length,
        },
        {
          label: 'Items to Show',
          path: 'itemsToShow',
          width: '105px',
          render: (cell) => cell || 0,
        },
        {
          label: 'Extra Items',
          path: 'extraItems',
          width: '105px',
          render: (cell, row) => row.items.length - row.itemsToShow || 0,
        },
        {
          label: 'Status',
          path: 'status',
          width: '180px',
          render: (_, row) => {
            const requiredPublishedItems = row.itemsToShow + 1;
            const publishedItemCount = row.items.filter((item) => item.status === 'PUBLISHED').length;
            return (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {publishedItemCount < requiredPublishedItems && (
                  <Tooltip
                    title={`Missing (${requiredPublishedItems - publishedItemCount}) published items`}
                    position="top"
                  >
                    <Icon name="warning" style={{ fontSize: 26, marginRight: 10 }} />{' '}
                  </Tooltip>
                )}
                <Tag color={publishedItemCount >= requiredPublishedItems ? 'green' : 'grey'}>
                  P: {row.items.filter((item) => item.status === 'PUBLISHED').length}
                </Tag>
                <Tag color="grey">U: {row.items.filter((item) => item.status === 'UNPUBLISHED').length}</Tag>
                <Tag color="grey">D: {row.items.filter((item) => item.status === 'DRAFT').length}</Tag>
              </div>
            );
          },
        },
        {
          label: 'Actions',
          path: 'action',
          width: '105px',
          render: (cell, row) => {
            return (
              <div>
                <Button icon="delete" onClick={() => props.onDelete(row)} />{' '}
                <Button
                  icon="edit"
                  onClick={() => browserHistory.push(`/placement-test/ruler/${row.ruler || 'default'}/${row.id}`)}
                />
              </div>
            );
          },
        },
      ]}
      rows={props.placementTests}
    />
    <small>
      {props.placementTests.reduce((acc, test) => acc + (test.items.length || 0), 0)} item
      {props.placementTests.reduce((acc, test) => acc + (test.items.length || 0), 0) > 1 && 's'} found.
    </small>
    <br />
    <small>
      {props.placementTests.reduce(
        (acc, test) => acc + (test.items.filter((item) => item.status === 'PUBLISHED').length || 0),
        0
      )}{' '}
      published item
      {props.placementTests.reduce(
        (acc, test) => acc + (test.items.filter((item) => item.status === 'PUBLISHED').length || 0),
        0
      ) > 1 && 's'}{' '}
      found.
    </small>
    <br />
    <small>
      {props.placementTests.reduce((acc, test) => acc + (test.itemsToShow || 0), 0)} item
      {props.placementTests.reduce((acc, test) => acc + (test.itemsToShow || 0), 0) > 1 && 's'} to show.
    </small>
  </div>
);

PlacementTestList.propTypes = {
  placementTests: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      placementTestLevel: PropTypes.shape({
        id: PropTypes.string.isRequired,
        level: PropTypes.number.isRequired,
      }).isRequired,
      grammar: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
  fetching: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default PlacementTestList;
